import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门彩种',
    links: [
      { label: '双色球', path: '/category/shuangseqiu' },
      { label: '大乐透', path: '/category/daletou' },
      { label: '福彩3D', path: '/category/fucai3d' },
      { label: '排列三', path: '/category/pailiesan' },
      { label: '七星彩', path: '/category/qixingcai' },
    ],
  },
  {
    title: '服务支持',
    links: [
      { label: '新手指南', path: '/article/qixingcai-xinshou-zhinan' },
      { label: '玩法规则', path: '/article/fucai3d-wanfa-jiedu' },
      { label: '理性购彩', path: '/article/licaigoucaizhi-lixngtouzhu' },
      { label: '常见问题', path: '/about' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '用户协议', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-treasure-map-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                彩客网
              </span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed mt-3">
              专业彩票数据服务平台，提供极速彩票数据查询、开奖结果实时推送、智能分析预测等核心服务。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; 2015-2024 彩客网 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-secondary-400 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-400 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-400 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
              <i className="ri-mail-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}